import { Action } from './Action.js';
/**
 * @class Forward
 * @extends Action
 * @classdesc �������� ������
 * ����������� �� ������� �������� ������
 * */
export class Forward extends Action {		
	execute() {
		window.history.forward();
	}       
}